import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getToken, getImpersonationHeader } from "../../lib/auth";
import { getAuthHeader, checkIfTokenExpired } from "./helpers";

const cache = new InMemoryCache({});

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_V3_API_HOST}`,
});

const authLink = setContext(async (_, { headers }) => {
  // NOTE: tmp fix for the `jwt expired` errors we are seeing throughout jobs
  // In the future, Auth0 will handle this for us
  if (process.env.REACT_APP_AUTH_IMPL !== "auth0") {
    await checkIfTokenExpired();
  }
  const token = await getToken();

  return {
    headers: {
      ...headers,
      ...getAuthHeader(token),
      ...getImpersonationHeader(),
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export default apolloClient;
